import { InvalidParamsRpcError, UserRejectedRequestError } from 'viem';

export const isViemError = (error: unknown) =>
  error instanceof InvalidParamsRpcError ||
  error instanceof UserRejectedRequestError;
